import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import Grid from "@material-ui/core/Grid";
import {OrganizationsTableConnected} from "./organization/OrganizationsTableConnected";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";


const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 250,
        margin: theme.spacing(2)
    },
    action: {
        justifyContent: 'flex-end'
    },
    table: {
        marginTop: '2rem',
        display: 'flex',
        justifyContent: 'center'
    },
    actions: {
        '& > *': {
            marginLeft: theme.spacing(2)
        }
    }
}));


export const OrganizationsTableMultiPicker = ({onSave, onCancel, preselectedIds, ...props}: any) => {
    const classes = useStyles();
    const [selectedOrganizations, setSelectedOrganizations] = useState(new Map());
    const {t} = useTranslation();

    const onOrganizationChecked = (o: any, e: any) => {
        const checked = e.target.checked;
        setSelectedOrganizations(oldSet => {
            const newSet = new Map(oldSet);
            if (checked) newSet.set(o.id, o);
            else if(!checked && newSet.has(o.id)) newSet.delete(o.id);
            return newSet;
        })
    }

    const actions = (o: any) => <Checkbox
        disabled={preselectedIds?.has(o.id)}
        checked={selectedOrganizations.has(o.id) || preselectedIds?.has(o.id)}
        onChange={e => onOrganizationChecked(o, e)}
        color="primary"
        inputProps={{'aria-label': 'primary checkbox'}}
    />;

    return (
        <Grid container spacing={3}>
            <Grid container item xs={12}>
                <OrganizationsTableConnected {...props} actions={actions}/>
            </Grid>
            <Grid container item justify="flex-end" className={classes.actions}>
                <React.Fragment>
                    <Button variant="outlined" color="primary" size="medium"
                            onClick={onCancel}>
                        {t('_Common.Labels.Cancel')}
                    </Button>
                    <Button variant="contained"
                            color="primary"
                            size="medium"
                            onClick={() => onSave(new Map(selectedOrganizations))}>
                        {t('_Common.Labels.Apply')}
                    </Button>
                </React.Fragment>
            </Grid>
        </Grid>
    )
};
